<template>
  <div>
    <el-dialog width="400px" v-model="form.dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" title="充值续费">
      <el-form :model="form" label-position="top" style="text-align: center;">
        <el-image style="width: 100px; height: 100px" :src="require('@/assets/logo.png')" :fit="fit" />
        <div class="pt-8 pb-8"><text style="font-weight: bolder;">标准版包月套餐</text></div>
        <div class="pt-8 pb-8"><text style="color: #ff6382;">限时4.9折 99 RMB /月</text></div>
        <div class="pt-8 pb-8"><text style="color: #fc3960;">新用户 1 RMB /月</text></div>
        <div class="pt-8 pb-8"><text style="color: #cecece; text-decoration: line-through;">原价 202 RMB /月</text></div>
        <div class="pt-32">
          <el-image style="width: 100px;" :src="require('@/assets/alipay.png')" :fit="fit" />
          <!-- <el-image style="width: 100px;" :src="require('@/assets/wxpay.png')" :fit="fit" /> -->
        </div>
        <el-radio-group v-model="form.radio1" size="small" @change="handleRadioChange">
          <el-radio label="支付宝" />
          <!-- <el-radio label="微信"/> -->
        </el-radio-group>
        <div class="pt-32">
          <el-button style="width:200px" type="primary" :disable='form.btnDisable' @click="submit">支 付</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from "vue";
import { useRouter, useRoute } from 'vue-router'
import { http, httpNoLoading } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  props: {
    visible: {
      type: String,
      default: false
    }
  },
  setup(props) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const form = reactive({
      radio1: '支付宝',
      radio2: '',
      btnDisable: true,
      dialogFormVisible: props.visible,
    })

    // 页面传来的事件处理
    vueEvent.on('payDialogVisible', (flag) => {
      form.dialogFormVisible = flag
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {

    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('payDialogVisible', () => { })
    })

    // 按钮提交事件
    const submit = (e) => {
      if (form.radio1.trim() === '') {
        ElMessage({ showClose: true, message: '请选择' })
        return false
      }
      // form.dialogFormVisible = false
      sendPost()
    }

    // 提交后台
    const sendPost = () => {
      let formData = new FormData()
      formData.append("pay", form.radio1 + ' ' + form.radio2)
      formData.append("total_amount", "0.01")
      formData.append("subject", "包月套餐")
      http({
        url: `/pay`,
        method: 'post',
        data: formData
      }).then((res) => {
        if (res.data.data != "") {
          var pay_url = res.data.data
          window.location.href = pay_url // 跳转支付宝付款页面
          // form.dialogFormVisible = false
        }
      })
    }

    return {
      form,
      submit
    }
  }
}
</script>
<style lang="scss" scoped></style>
